import React, { useState } from 'react';
import { Card, Tabs, Typography } from 'antd';
import { ToolOutlined, ShoppingOutlined } from '@ant-design/icons';
import ServiceTemplateList from './ServiceTemplateList';
import PartTemplateList from './PartTemplateList';

const { Title } = Typography;

const TemplateManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('services');

  const tabItems = [
    {
      key: 'services',
      label: (
        <span>
          <ToolOutlined />
          Service Templates
        </span>
      ),
      children: <ServiceTemplateList />,
    },
    {
      key: 'parts',
      label: (
        <span>
          <ShoppingOutlined />
          Part Templates
        </span>
      ),
      children: <PartTemplateList />,
    },
  ];

  return (
    <div style={{ padding: '24px', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <div style={{ marginBottom: '24px', textAlign: 'center' }}>
        <Title level={2} style={{ margin: 0 }}>Template Management</Title>
        <p style={{ color: '#666', marginTop: '8px' }}>
          Manage service and part templates for estimates and work orders
        </p>
      </div>

      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          size="large"
          centered
        />
      </Card>
    </div>
  );
};

export default TemplateManagement;